export const getFaqMasterFilter = state => state.faqMaster.filter
